import { render, staticRenderFns } from "./F2.vue?vue&type=template&id=c8c763ca&scoped=true"
import script from "./F2.vue?vue&type=script&lang=js"
export * from "./F2.vue?vue&type=script&lang=js"
import style0 from "./F2.vue?vue&type=style&index=0&id=c8c763ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c763ca",
  null
  
)

export default component.exports